import * as Yup from "yup";
import { ROLES } from "types/user";

export const initialValues = {
  name: "",
  email: "",
  role: ROLES.ADMIN,
};

export const getValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string().required("This field is required"),
    email: Yup.string()
      .email("Invalid email")
      .required("This field is required"),
    role: Yup.string().required("This field is required"),
  });
